import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Image, Stack, Text, rem } from '@mantine/core';
import { ProfileCharacter } from './ProfileCharacter';
export const ProfileCongratsMobile: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack hiddenFrom="sm" mb={40}>
      <Image src="/assets/kyc/shield.svg" alt="shield" w={80} h={80} mx="auto" />
      <Box>
        <Text fz={28} c="var(--text-prime)" className={gunterzBold.className} ta="center">
          {i18n._('Congrats,')}
          <Text span c="var(--text-white)" inherit>
            {i18n._(' you’re Armored up! ')}
          </Text>
        </Text>
      </Box>

      <Divider size="sm" c="var(--icon-primary)" />

      <Text fz={rem(20)} w={396} c="var(--text-dark)" className={gunterzBold.className} ta="center" tt="uppercase">
        {i18n._('You’ve unlocked a ')}
        <Text span inherit c="var(--text-pink)">
          {i18n._('legendary ')}
        </Text>
        {i18n._('ARMOR')}
      </Text>

      <Divider size="sm" c="var(--icon-primary)" />

      <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} ta="center">
        {i18n._('Your PrimeOrb is now equipped and ready for battle. Want to push it even further?')}
      </Text>

      <Text fz="xs" c="var(--text-prime)" tt="uppercase" fw={700} ta="center">
        {i18n._('Play for more exclusive items in the Lootboxes or head to the Bunker to customize and upgrade your PrimeOrb ')}
        <Text span inherit c="var(--text-dark)">
          {i18n._('for ultimate performance')}
        </Text>
      </Text>

      <ProfileCharacter />
    </Stack>;
};